import { customerFields } from "./CustomerFormField";
import { useEffect, useState } from "react";
import { toast } from "../../../components/AppToast";
import { getCustomerID } from "../../../services/customer/customer";
import { getChannel } from '../../../services/channel/channel';
import { useDispatch, useSelector } from "react-redux";
import { countryList } from "../../../data/static";
export default function CreateCustomer({ initialValues, onSubmit, onCancel, viewOnly, isEdit }) {
    const {userDetail} = useSelector(state=>state.login)
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [channels,setChannelsData] = useState();
    const [formData, setFormData] = useState({
        custId: '',
        custName: '',
        phone: '',
        email: '',
        channel: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        pinCode: '',
        createdBy: '',
        updatedBy: '',
        updatedDate: '',
        
    })

    const countries = countryList;


    const handleChange = async (name, value) => {
        setFormData({ ...formData, [name]: value });
    }

    const submit = async (e) => {
        e.preventDefault();
        try {
            if (isEdit) {
                const finalData = { ...formData };
                await onSubmit(finalData, initialValues._id);
            } else {
                const finalData = { ...formData, tenantId:userDetail.tenantId._id };
                await onSubmit(finalData);
            }
        } catch (err) {
            if (err?.data?.message) {
                toast.error(err.data.message);
            } else {
                toast.error("Error saving carton");
            }
        }
    }

    useEffect(() => {
        if ((viewOnly || isEdit) && initialValues) {
 
            setFormData({ ...initialValues,address1:initialValues.defaultAddress.address1,address2:initialValues.defaultAddress.address2,city:initialValues.defaultAddress.city,state:initialValues.defaultAddress.state,country:initialValues.defaultAddress.country,pinCode:initialValues.defaultAddress.pinCode });
        if(isEdit){
            setFormData(prev=>({...prev,updatedBy:userDetail.email,updatedDate:new Date()}));
        }
        else{
             setFormData(prev=>({...prev,updatedBy:initialValues.updatedBy,updatedDate:initialValues.updatedDate}));
        }
        }

    }, [viewOnly, isEdit, initialValues])


    useEffect(() => {
       
        fetchChannels();
        if (!viewOnly && !isEdit) {
            formData.createdBy = loggedInUser;
            getCustomerIDFn();
            setFormData(prev=>({...prev , createdBy:userDetail.email}))
        }
    }, [])


    const getCustomerIDFn = async () => {
        let custIdd = await getCustomerID();
        if (custIdd.success === true) {
            setFormData(prev => ({
                ...prev,
                custId: custIdd.data
            })
            )
        }
    }

       const fetchChannels = async () => {
            try {
                const data = await getChannel(); // your API call
                setChannelsData(data);
            } catch (err) {
                console.error("Error fetching channels:", err);
            }
        };




    return (
        <form>
            <div className="d-flex flex-wrap gap-3">
                {customerFields.map((field) => (
                    <div
                        key={field.name}
                        className="mb-1"
                        style={{ flex: `0 0 ${field.width || "15%"}` }}

                    >
                        <label className="form-label">
                            {field.label}
                            {field.required && <span className="text-danger"> *</span>}
                        </label>

                        {field.type === 'select' ? (
                            <select
                                className="form-select"
                                value={formData[field.name] || ""}
                                onChange={(e) => handleChange(field.name, e.target.value)}
                                disabled={viewOnly || isEdit}
                            >
                                <option value="" style={{ fontSize: '12px' }}>Select</option>

                                {field.name === 'country' && countries?.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}

                                {field.name === 'channel' && channels?.map((opt) => (
                                    <option key={opt.channel_Id} value={opt.channel_Id}>{opt.channel_Name}</option>
                                ))}


                            </select>
                        ) :
                            (<input
                                type={field.type || "text"}
                                className="form-control"
                                value={formData[field.name] || ""}
                                onChange={(e) => handleChange(field.name, e.target.value)}
                                readOnly={viewOnly || field.readonly}
                            />)
                        }
                    </div>
                ))}
            </div>

            <div className="d-flex justify-content-center gap-2 mt-3">
                <button className="btn btn-secondary" onClick={onCancel}>
                    Back
                </button>
                <button
                    className="btn btn-primary"
                    onClick={submit}

                    style={{ display: !viewOnly && !isEdit ? 'inline-flex' : 'none' }}
                >
                    Save
                </button>


                <button className="btn btn-primary"
                    onClick={submit}
                    style={{ display: isEdit && !viewOnly ? 'inline-flex' : 'none' }}
                >
                    Update
                </button>
            </div>
        </form>
    )
}
